const SplitIcon = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
            d="M10.6667 2L14 2M14 2V5.33333M14 2L10 6M5.33333 2L2 2M2 2L2 5.33333M2 2L7.21867 7.21867C7.46983 7.46971 7.66832 7.76839 7.80249 8.09718C7.93666 8.42597 8.00381 8.77824 8 9.13333L8 14.6667"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default SplitIcon;
